import { render } from "./LessonsPreviewPage.vue?vue&type=template&id=baf393c6&ts=true"
import script from "./LessonsPreviewPage.vue?vue&type=script&lang=ts"
export * from "./LessonsPreviewPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__